import axios from 'axios';
import { User } from '../types/User';
import { WizardState } from '../types/WigWizard';

// const BASE_URL = 'http://localhost:3000'
const BASE_URL = 'https://meta-data-server.herokuapp.com'


export function saveUserMeasureMents({ capSize, laceTint, laceTintDescription, s3BucketFolder }: WizardState, user: User) {
  axios.post(
    `${BASE_URL}/measurements/`,
    { capSize, laceTint, laceTintDescription, s3BucketFolder, id: user.id },
    { headers: { authorization: user.hashedId } }
  )
}

export async function saveWigStyle({ user, sku, id }: { user: User, sku: string, id: number }): Promise<string> {
  const { data: { styleId } } = await axios.post(
    `${BASE_URL}/styles/`,
    {
      url: location.pathname + location.search,
      id: user.id,
      sku,
      variantId: id,
    },
    { headers: { authorization: user.hashedId } }
  )
  return styleId
}

export async function updateWigStyle({ styleId, user, sku, id }: { styleId: string, user: User, sku: string, id: number }): Promise<any> {
  return axios.put(
    `${BASE_URL}/styles/${styleId}`,
    {
      url: location.pathname + location.search,
      id: user.id,
      sku,
      variantId: id,
    },
    { headers: { authorization: user.hashedId } }
  )
}

export async function removeWigStyle({ user, id }: { user: User, id: string }): Promise<string> {
  return axios.put(
    `${BASE_URL}/styles/delete/${id}`,
    {
      id: user.id,
    },
    { headers: { authorization: user.hashedId } },
  )
}
